import React, {Component} from 'react';
import {  Link } from 'react-router-dom'; 
  
import { base_url} from '../common/Constants';
 


 
class PageHeader extends React.Component{
 
    render()
    { 

        return ( <div class="breadcrumb-area shadow dark bg-fixed text-center text-light" style={{backgroundImage:`url(`+base_url+`assets/img/banner-10.png)`}}  >
        <div class="container">
            <div class="row">
                <div class="col-lg-12 col-md-12">
                    <h1>{this.props.title}</h1>
                    <ul class="breadcrumb">
                        <li><Link to="/"><i class="fas fa-home"></i> Home</Link></li>
                        <li><Link to="/">Pages</Link></li>
                        <li class="active">{this.props.title}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
        );
     
}

}

export default PageHeader;